// SqureApp color code
// const colors = {
//   background: '#264d6b',
//   primary: '#264d6b',
//   secondary: '#666360',
//   light: '#f4f4f4',
//   error: '#e53935',
//   warning: '#fdd835',
// };

// // SenecuraApp color code
// const colors = {
//   background: '#039be5',
//   primary: '#039be5',
//   secondary: '#666360',
//   light: '#f4f4f4',
//   error: '#e53935',
//   warning: '#fdd835',
// };

// SenevitaApp color code
// const colors = {
//   background: '#128c8e',
//   primary: '#128c8e',
//   secondary: '#666360',
//   light: '#f4f4f4',
//   error: '#e53935',
//   warning: '#fdd835',
// };

// gasconnect color code
const colors = {
  background: '#039be5',
  primary: '#039be5',
  secondary: '#666360',
  light: '#f4f4f4',
  error: '#e53935',
  warning: '#fdd835',
};

// Note: For the GasConnect server, uncomment the following changes in:
// \src\pages\signin\styles.js
//
// background: url(${signInBackgroundImage}) no-repeat center;
// This applies the background image for the GasConnect server.

export default colors;
